import { OverlayModule } from '@angular/cdk/overlay';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { KpiCardWrapDirective } from 'app/directives/kpi-card-wrap/kpi-card-wrap.directive';
import { SharedPipesModule } from 'app/pipes/shared-pipes.module';

import { CdsTooltipModule } from '../cds-tooltip/cds-tooltip.module';
import { KpiComponent } from '../kpi-card/kpi/kpi.component';
import { KpiCardComponent } from '../kpi-card/kpi-card.component';
import { KpiTooltipModule } from '../kpi-tooltip/kpi-tooltip.module';
import { KpiTrendIndicatorModule } from '../kpi-trend-indicator/kpi-trend-indicator.module';
import { StatusBadgeModule } from '../status-badge/status-badge.module';

@NgModule({
  declarations: [KpiCardComponent, KpiComponent],
  exports: [KpiCardComponent, KpiComponent],
  imports: [
    BrowserModule,
    OverlayModule,
    CdsTooltipModule,
    StatusBadgeModule,
    KpiTrendIndicatorModule,
    KpiTooltipModule,
    SharedPipesModule,
    MatIconModule,
    KpiCardWrapDirective
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KpiCardModule {}
